import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFeatureUserSettings } from 'selectors';
import { featureEnabled } from 'utilities/featureFlag';
import { trackSegmentEvent as trackSegmentEventAction } from '../../../actions';

const EXPERIMENT_EVENT_NAME = 'Launch Darkly Experiment';

const validExperiment = (isExperiment, experimentName) => (
  isExperiment && experimentName && (experimentName.length > 0)
);

const createEventPayload = ({
  flagName, experimentName, flagEval, featureUserSettings
}) => {
  const {
    key,
    custom: {
      cohortMembershipKey,
      cohortMemberType
    }
  } = featureUserSettings;

  return {
    userId: key,
    event: EXPERIMENT_EVENT_NAME,
    properties: {
      cohortMembershipKey,
      cohortMemberType,
      name: flagName,
      test: experimentName,
      flagEval
    }
  };
};

// NOTE: In order to track variants in Segment, you MUST pass "trackVariant" prop to toggle it on
const FeatureToggle = (props) => {
  const {
    flag: flagName,
    isExperiment,
    experimentName,
    trackExperiment,
    featureUserSettings,
    OnTrueComponent,
    OnFalseComponent,
    ...rest
  } = props;
  const flagEval = featureEnabled(flagName);

  // trigger the segment event before rendering
  if (validExperiment(isExperiment, experimentName)) {
    const payload = createEventPayload({
      flagName, experimentName, flagEval, featureUserSettings
    });
    trackExperiment(payload);
  }
  if (flagEval) {
    return <OnTrueComponent {...rest} />;
  }
  return <OnFalseComponent {...rest} />;
};

FeatureToggle.propTypes = {
  flag: PropTypes.string.isRequired,
  isExperiment: PropTypes.bool,
  experimentName: PropTypes.string,
  trackExperiment: PropTypes.func.isRequired,
  featureUserSettings: PropTypes.object.isRequired,
  OnTrueComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  OnFalseComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

FeatureToggle.defaultProps = {
  isExperiment: false,
  experimentName: null,
  OnTrueComponent: () => null,
  OnFalseComponent: () => null,
};

const mapStateToProps = (state) => {
  const featureUserSettings = getFeatureUserSettings(state);

  return {
    featureUserSettings
  };
};

const mapDispatchToProps = dispatch => ({
  trackExperiment: payload => dispatch(trackSegmentEventAction(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureToggle);
